import React, { useState, useRef, forwardRef } from 'react';
import { Input, icons } from 'daymap-library';
import { FontIcon } from '@fluentui/react';

import styles from './StudentCodeInput.module.scss';

const StudentCodeInput = forwardRef(function StudentCodeInput({value, onChange, config, elementType}, ref) {
    const codeChanged = e => {
        onChange && onChange(e.target.value);
    }

    return (
        <div className={styles.Wrapper}>
            <FontIcon iconName={icons.ICON_CSS_CLASS.Visitor} />
            <Input elementType={elementType} className={styles.StudentCodeInput} value={value} onChange={codeChanged} ref={ref} config={config} />
        </div>
    )
});

export default StudentCodeInput;